/*
 * AppReducer
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 * @param  {state} login state
 * @param  {action} login action
 */
import { createReducer, updateObject } from 'Stores'
import { HIDE_MODAL_MESSAGE, HIDE_OVERLAY, HOVER_SIDEBAR, SHOW_MODAL_MESSAGE, SHOW_OVERLAY, TOGGLE_SIDEBAR } from './constants'

export const initialState = {
  sidebarCompact: false,
  sidebarHover: false,
  isShowModalMessage: false,
  message: null,
  type: null,
  isShowOverlay: false,
  portfolios: [
    {
      achivement_content: null,
      client_name: 'Portfolio 1',
      description: null,
      goal_content: null,
      headcount_folder_id: '01O6XHQ65D4EWUIEWKDVFI3D26YEAXXMX2',
      id: 50,
      number_of_member: 1,
      role: 'COMPANY_ADMIN',
      time_to_ipo: null,
      weekly_folder_id: '01O6XHQ67RKVYLBWWSRBH3NTK4FKXY3EBP'
    },
    {
      achivement_content: null,
      client_name: 'Portfolio 2',
      description: null,
      goal_content: null,
      headcount_folder_id: '01O6XHQ65D4EWUIEWKDVFI3D26YEAXXMX2',
      id: 51,
      number_of_member: 1,
      role: 'COMPANY_ADMIN',
      time_to_ipo: null,
      weekly_folder_id: '01O6XHQ67RKVYLBWWSRBH3NTK4FKXY3EBP'
    }
  ]
}

function toggleSidebar(state, { payload }) {
  if (payload === false || payload === true) {
    return updateObject(state, {
      sidebarCompact: payload
    })
  }
  return updateObject(state, {
    sidebarCompact: !state.sidebarCompact
  })
}

function hoverSidebar(state) {
  return updateObject(state, {
    sidebarHover: !state.sidebarHover
  })
}

function showModalMessage(state, { payload }) {
  const { message, type } = payload
  return updateObject(state, {
    isShowModalMessage: true,
    message,
    type
  })
}

function hideModalMessage(state) {
  return updateObject(state, {
    isShowModalMessage: false,
    message: null
  })
}

function showOverlay(state) {
  return updateObject(state, {
    isShowOverlay: true
  })
}

function hideOverlay(state) {
  return updateObject(state, {
    isShowOverlay: false
  })
}

export default createReducer(initialState, {
  [TOGGLE_SIDEBAR]: toggleSidebar,
  [HOVER_SIDEBAR]: hoverSidebar,
  [SHOW_MODAL_MESSAGE]: showModalMessage,
  [HIDE_MODAL_MESSAGE]: hideModalMessage,
  [SHOW_OVERLAY]: showOverlay,
  [HIDE_OVERLAY]: hideOverlay
})
